const EMAIL_SIGNUP_POPUP_MIN_DELAY = 15000;

class EmailSignUpPopup extends ModalDialog
{
  constructor() {
    super();
    this.key = `email-signup-popup-${Shopify.shop.replace('.myshopify.com', '')}`;
    this.moved = true;
    this.openTimer = null;
    this.contentTimer = null;
    this.onCheckboxHandler = null;
    this.schedulePopup();
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.contentTimer);

    const checkbox = this.querySelector('.email-signup-popup__checkbox');
    if(this.onCheckboxHandler && checkbox) {
      checkbox.removeEventListener('change', this.onCheckboxHandler);
    }
  }

  getDelayTime() {
    const delayTime = parseInt(this.dataset.delayTime || '0', 10);
    const safeDelayTime = Number.isNaN(delayTime) ? 0 : delayTime;

    if (Shopify.designMode) return safeDelayTime;

    return Math.max(safeDelayTime, EMAIL_SIGNUP_POPUP_MIN_DELAY);
  }

  getExpirationDate() {
    const expirationDays = parseInt(this.dataset.expirationTime || '1', 10);
    const safeExpirationDays = Number.isNaN(expirationDays) ? 1 : Math.max(expirationDays, 1);

    return new Date(new Date().setDate(new Date().getDate() + safeExpirationDays)).toString();
  }

  suppressPopup() {
    BtStorageUtil.set(this.key, this.getExpirationDate());
  }

  isSuppressed() {
    const currentCookieValue = BtStorageUtil.get(this.key, false);

    if(currentCookieValue != null && currentCookieValue != '1') {
      const expirationTime = Date.parse(currentCookieValue);
      const now = (new Date()).getTime();

      return expirationTime > now;
    }

    return false;
  }

  schedulePopup() {
    if (Shopify.designMode || this.isSuppressed()) return;

    window.clearTimeout(this.openTimer);
    this.openTimer = window.setTimeout(() => {
      this.showPopup();
    }, this.getDelayTime());
  }

  loadContent() {
    fetch(window.Shopify.routes.root + `?section_id=${this.dataset.sectionId}&view=ajax`)
    .then((response) => response.text())
    .then((responseText) => {
      this.classList.add('loaded');
      const styles = getDomHtmlFromText(responseText, '.section-styles');
      if (styles) document.body.appendChild(styles);

      this.contentTimer = window.setTimeout(() => {
        if (this.isSuppressed()) return;

        const content = getDomHtmlFromText(responseText, '.popup-modal__content-info');
        const contentWrapper = this.querySelector('.popup-modal__content');
        if (content && contentWrapper && !contentWrapper.querySelector('.popup-modal__content-info')) {
          contentWrapper.appendChild(content);
        }

        this.openPopup();
        this.attachEvents();

        const checkbox = this.querySelector('.email-signup-popup__checkbox');
        if(checkbox && checkbox.checked) {
          this.suppressPopup();
        }
      }, 500);
    });
  }

  showPopup() {
    if(!this.isSuppressed() && !Shopify.designMode) {
      if(!this.classList.contains('loaded')) {
        this.loadContent();
      } else {
        this.openPopup();
        this.attachEvents();
      }
    }
  }

  openPopup() {
    this.show();
  }

  hide() {
    if(!Shopify.designMode && this.hasAttribute('open')) {
      this.suppressPopup();
    }

    super.hide();
  }

  attachEvents() {
    if (this.onCheckboxHandler) return;

    const checkbox = this.querySelector('.email-signup-popup__checkbox');
    if (!checkbox) return;

    this.onCheckboxHandler = this.onCheckboxChange.bind(this);
    checkbox.addEventListener('change', this.onCheckboxHandler);
  }

  onCheckboxChange(event) {
    if(event.target.checked) {
      this.suppressPopup();
    } else {
      BtStorageUtil.remove(this.key);
    }
  }
}

customElements.define('email-signup-popup', EmailSignUpPopup);
